<template>
  <div
    class="flex justify-center items-center"
    :class="`${additionalClasses} ${showBackground ? 'loader-container' : ''}`"
  >
    <div :class="spinnerAdditionalClasses" class="spinner">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  additionalClasses: {
    type: String,
    default: "",
  },
  spinnerAdditionalClasses: {
    type: String,
    default: "",
  },
  showBackground: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped>
.spinner {
  --gap: 2px;
  --clr: #d62d20;
  --height: 16px;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--gap);
}

.loader-container {
  background-color: black;
  opacity: 0.8;
}

.spinner span {
  width: 4px;
  height: var(--height);
  animation: grow 1s ease-in-out infinite;
  background: #66ff00;
}

.spinner span:nth-child(2) {
  animation: grow 1s ease-in-out 0.15s infinite;
  background: #ffff30;
}

.spinner span:nth-child(3) {
  animation: grow 1s ease-in-out 0.3s infinite;
  background: #ffbb00;
}

.spinner span:nth-child(4) {
  animation: grow 1s ease-in-out 0.475s infinite;
  background: #ff618b;
}

.spinner span:nth-child(5) {
  animation: grow 1s ease-in-out 0.65s infinite;
  background: #dc41fb;
}

@keyframes grow {
  0%,
  100% {
    transform: scaleY(1);
  }

  50% {
    transform: scaleY(1.8);
  }
}
</style>
